import { BoundSelectField, Css, useTestIds } from "@homebound/beam";
import { FieldState } from "@homebound/form-state";
import { StatusIndicator } from "src/components/StatusIndicator";
import { TaskStatusesFragment } from "src/fragments/circularFragments.generated";
import { TaskStatus } from "src/generated/graphqlTypes";
import { PotentialOperationDetailsFragment } from "src/queries/fragments.generated";
export type TaskStatusSelectProps = {
  label?: string;
  hideLabel?: boolean;
  hideStatusIndicator?: boolean;
  options: TaskStatusesFragment[];
  statusField: FieldState<TaskStatus | null | undefined>;
  canComplete: PotentialOperationDetailsFragment;
  canStart: PotentialOperationDetailsFragment;
  disabled: boolean;
  borderless?: boolean;
  dataTestId?: string;
  onSelect?: (status?: TaskStatus) => void;
};

export function TaskStatusSelect(props: TaskStatusSelectProps) {
  const {
    label,
    hideLabel,
    hideStatusIndicator,
    options,
    statusField,
    canComplete,
    canStart,
    disabled,
    borderless,
    dataTestId,
    onSelect,
  } = props;
  const invalidOptions = [TaskStatus.OnHold];

  if (statusField.value !== TaskStatus.Delayed) invalidOptions.push(TaskStatus.Delayed);

  const disabledCompleteOptionTooltip = canComplete.disabledReasons.map((dr) => dr.message).join(", ");
  const disabledInProgressOptionTooltip = canStart.disabledReasons.map((dr) => dr.message).join(", ");
  const tids = useTestIds({}, `${dataTestId ? dataTestId : ""}`);

  return (
    <BoundSelectField
      getOptionValue={(ts) => ts.code}
      getOptionLabel={(ts) => ts.name}
      options={options.filter((status) => !invalidOptions.includes(status.code))}
      label={label}
      labelStyle={hideLabel ? "hidden" : "above"}
      field={statusField}
      fieldDecoration={hideStatusIndicator ? undefined : (ts) => <StatusIndicator status={ts.code} />}
      getOptionMenuLabel={(ts) => (
        <div css={Css.df.aic.$}>
          {!hideStatusIndicator && <StatusIndicator status={ts.code} />}
          <span css={Css.ml1.$}>{ts.name}</span>
        </div>
      )}
      disabledOptions={[
        ...(canComplete.allowed ? [] : [{ value: TaskStatus.Complete, reason: disabledCompleteOptionTooltip }]),
        ...(canStart.allowed ? [] : [{ value: TaskStatus.InProgress, reason: disabledInProgressOptionTooltip }]),
      ]}
      disabled={disabled}
      borderless={borderless}
      onSelect={onSelect}
      {...tids.status}
    />
  );
}
